import { FC } from 'react';
import { ComponentRendering, Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { icon_basket } from '@gn-audio/icons';
import { Button, ComponentProps, JabraIcon, withTheme } from '@gn-audio/jss-components';

import { usePageProduct } from 'common/PageProductContext/pageProductContext';

export interface SupportSpotProps extends Omit<ComponentProps, 'rendering'> {
  rendering: {
    fields: {
      Heading: Field<string>;
      MainText: Field<string>;
      ButtonText: Field<string>;
      BackgroundColor: Field<string>;
    };
  } & ComponentRendering;
  error?: { message?: string };
}

const SupportSpot: FC<SupportSpotProps> = ({ rendering }) => {
  const { product } = usePageProduct();
  if (Object.keys(rendering.fields).length === 0) return null;

  const heading = rendering.fields.Heading?.value;
  const mainText = rendering.fields.MainText?.value;
  const buttonText = rendering.fields.ButtonText?.value;

  return (
    <div className="bg-theme container-fluid">
      <div className="container mx-auto flex flex-col items-center text-center">
        <h2 className="heading-2">{heading}</h2>
        <p className="paragraph-large mb-6">{mainText}</p>
        <Button
          asLink
          href={product?.supportPageUrl}
          size="m"
          variant="primary"
          title={buttonText}
          icon={<JabraIcon Icon={icon_basket} />}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default withTheme({ legacyBackgroundFieldName: 'BackgroundColorShared' })(
  withDatasourceCheck()(SupportSpot)
);
